<template>
    <transition name="product-configurator-transition">
        <div id="product-configurator" class="product-configurator" v-show="shouldShowConfigurator" v-if="isDataReady">
            <product-intro v-if="shouldShowIntro">
                <span v-html="introMessage"></span>
            </product-intro>

            <div class="scene" v-show="shouldShowProduct">
                <assembled-product-zoom v-show="shouldShowAssembledProductZoomImage"
                    :isDesktop="isDesktop"
                    :productZoomStyle="initialProductZoomStyle">
                </assembled-product-zoom>

                <transition name="assembled-product-transition">
                    <assembled-product v-if="shouldShowAssembledProductImage"
                        :isVisible="shouldShowProduct"
                        :isTablet="isTablet"
                        :isDesktop="isDesktop"
                        :isOverlayVisible="isOverlayVisible"
                        :isUpsellScreen="shouldShowUpsellFooter"
                        @productStyleSet="onProductStyleSet"
                        @clickBackButton="onClickUpsellBackButton">
                    </assembled-product>

                    <result-slider v-if="shouldShowResultScreen"
                        :isDesktop="isDesktop"
                        @shouldHideResultFooter="onHideResultFooter"
                        @clickBackButton="onClickResultBackButton">
                    </result-slider>
                </transition>

                <transition :name="transitionName">
                    <upsell-footer v-if="shouldShowUpsellFooter" key="upsellFooter"
                        :class="partsFooterClass"
                        :isMobile="isMobile"
                        :isTablet="isTablet"
                        :isDesktop="isDesktop"
                        :upsellBackButtonClicked="upsellBackButtonClicked"
                        @clickDonePartsButton="onClickDoneUpsellButton">
                    </upsell-footer>
                    <parts-footer v-if="shouldShowPartsFooter" key="partsFooter"
                        :class="partsFooterClass"
                        :isDesktop="isDesktop"
                        @clickCancelPartsButton="onClickCancelPartsButton"
                        @clickDonePartsButton="onClickDonePartsButton">
                    </parts-footer>
                    <options-footer v-if="shouldShowOptionsFooter" key="optionsFooter"
                        :isMobile="isMobile"
                        :isTablet="isTablet"
                        :isDesktop="isDesktop"
                        @overlayChange="onOverlayChange"
                        @optionFooterChange="onOptionFooterChange">
                    </options-footer>
                    <result-footer v-if="shouldShowResultFooter" key="resultFooter"
                        :isDesktop="isDesktop"
                        :shouldShowButtons="shouldShowResultFooterButtons"
                        @clickDetails="onClickResultDetailsButton"
                        @clickAddToCart="onClickResultAddToCartButton">
                    </result-footer>
                </transition>

                <transition name="footer-backdrop-transition">
                    <div class="backdrop" v-show="isDesktop && shouldShowFooter">
                    </div>
                </transition>
            </div>

            <transition name="backdrop-transition">
                <div class="backdrop" v-show="shouldShowBackdrop">
                </div>
            </transition>

            <transition name="scrim-transition">
                <div class="scrim" v-show="shouldShowBackdrop">
                </div>
            </transition>
        </div>

        <!--
            If for whatever reason we cannot load the data we show the dialog
            below instead of the configurator.
        -->
        <div id="product-configurator" class="product-configurator has-dialog" v-if="shouldShowDialog">
            <transition name="dialog-transition">
                <div class="dialog" v-show="shouldShowDialog">
                    <button type="button" class="icon-close" @click="onClickCancelDialogButton">
                        <span class="sr-only">{{ dialogResources.close }}</span>
                    </button>
                    <p>
                        {{ dialogMessage }}
                    </p>
                    <a href="javascript:void(0);" v-if="isMobile" @click="onClickCancelDialogButton">
                        {{ dialogResources.close }}
                    </a>
                    <button type="button" class="btn btn--secondary" v-if="!isMobile" @click="onClickCancelDialogButton">
                        {{ dialogResources.close }}
                    </button>
                </div>
            </transition>

            <transition name="scrim-dialog-transition">
                <div class="scrim" v-show="shouldShowDialog" @click="onClickCancelDialogButton">
                </div>
            </transition>
        </div>
    </transition>
</template>

<script src='./product-configurator.js'></script>
